<template>
  <section class="pdf-add-wrapper">
    <b-row
      v-for="(page, pageIndex) in pages"
      :key="'page' + pageIndex"
      style="padding-bottom: 0"
    >
      <!-- Col: Left (Refund Container) -->
      <b-col
        cols="12"
        class="pdf-add"
        style="margin-bottom: 0; padding-bottom: 0"
      >
        <b-card
          no-body
          class="pdf-preview-card"
          style="margin-bottom: 0; padding-bottom: 0"
        >
          <!-- Header -->
          <div
            class="pdf_header pdf-padding pt-2"
            style="margin-bottom: 0; padding-bottom: 0"
          >
            <div class="logo">
              <img class="d-block mx-auto" :src="info.logo_url" />
              <h3 class="mx-auto d-table">退款 Refund</h3>
            </div>

            <div class="license color0">
              <div class="license-content" v-html="info.company_info"></div>
            </div>
            <div class="pdf-form">
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title"> 客戶： </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.name_cn }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="4" class="text-right title">
                      退款編號：
                    </b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value pdf-number colorRed">
                        {{ pdfData.refund_number }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      工程地址：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.address }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="4" class="text-right title">
                      發單日期：
                    </b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.refund_date }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="form-item">
                <b-col clas="left" cols="7">
                  <b-row>
                    <b-col cols="3" class="text-right title">
                      聯絡電話：
                    </b-col>
                    <b-col cols="9" class="text">
                      <div class="form-value">
                        {{ pdfData.mobile ? pdfData.mobile : '-' }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col clas="right" cols="5">
                  <b-row>
                    <b-col cols="4" class="text-right title">
                      收據編號：
                    </b-col>
                    <b-col cols="8" class="text">
                      <div class="form-value">
                        {{ pdfData.receipt && pdfData.receipt.receipt_number }}
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <!-- Spacer -->
          <div
            class="pdf-padding form-item-section"
            style="padding-top: 0; padding-bottom: 0; margin-bottom: 0"
          >
            <div class="pdf-table refund" style="height: 15.1cm">
              <div class="line a"></div>
              <div class="line b"></div>
              <div class="line c"></div>
              <div class="d-flex">
                <div style="width: 100px;" class="thead-label">
                  退款日期
                </div>
                <div style="width: 280px;" class="thead-label">
                  退款項目 Description
                </div>
                <div style="width: 193px;" class="thead-label">
                  款項摘要
                </div>
                <div style="width: 95px;" class="thead-label">
                  金額(HK$)
                </div>
              </div>

              <div
                v-for="(item, index) in page"
                :key="index"
                ref="row"
                class="d-flex pdf-item"
                :class="{ 'mt-25': index == 0 }"
              >
                <!-- 退款日期 -->
                <div style="width: 100px;" class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">{{ item.payment_date || item.refund_date }}</span>
                </div>

                <!-- 退款項目 Description -->
                <div style="width: 280px;" class="pdf-item-text-wrapper">
                  <span class="pdf-item-text">
                    <template v-if="item.invoice_number">
                      [{{ item.invoice_number }}] {{ item.step_phase }}{{ item.step_name ? '-' + item.step_name : '' }} {{ item.payment_date }} ${{ formatMoney(item.amount) }}
                    </template>
                    <template v-else>
                      {{ item.item_description || '--' }}
                    </template>
                  </span>
                </div>

                <!-- 款項摘要 -->
                <div style="width: 193px;" class="pdf-item-text-wrapper">
                  <span class="pdf-item-text" v-html="changeNextLine(item.item_description|| '--')"></span>
                </div>

                <!-- 金額(HK$) -->
                <div style="width: 95px; margin-right:5px;" class="pdf-item-text-wrapper">
                  <span
                    class="pdf-item-text text-right normal-text"
                    v-if="item.amount != 0 || controlValue.showZero"
                    >{{ formatMoney(item.amount) }}
                  </span>
                </div>
              </div>
            </div>

            <div
              class="pdf-table-amount refund"
              :class="{ 'not-finish': pageIndex < pages.length - 1 }"
            >
              <div></div>
              <span v-if="pageIndex == pages.length - 1" class="total-amount">{{
                getNumberFormat(getTotalAmount())
              }}</span>
              <span v-else class="total-amount">轉下頁</span>

              <img
                v-if="info.stamp_url"
                class="stamp_logo"
                :src="info.stamp_url"
                alt=""
              />
            </div>
          </div>
          <!-- Footer & Payment Detail -->
          <div class="pdf-padding pt-1">
            <div class="pdf-form sign">
              <div class="my-2 text-left remark">
                <label class="" v-if="pdfData.receipt_remark"
                  >備 註 Remarks:</label
                >
                <div
                  class="text-12"
                  v-html="changeNextLine(pdfData.receipt_remark)"
                />

                <!-- <ol class="pl-2">
                  <li>
                    交來票據兌現作實。Cheques are not recognised until bank
                    clearance.
                  </li>
                  <li>
                    This document is generated by computer and is genuine true
                    copy duly authorised by us. No manual signature will be
                    added unless request.此乃電腦列印文件，無須簽署。
                  </li>
                  <li>
                    All prices listed above is in Hong Kong Dollar (HKD)) unless
                    specified. 所有金額均為港元。
                  </li>
                </ol> -->
              </div>
              <hr class="w-100" />
              <div class="d-flex company-info flex-wrap mb-0">
                <div class="w-50">
                  <div class="d-flex">
                    <span>地址：</span>
                    <span>{{ info.address }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>網址：</span>
                    <span>{{ info.website }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電話：</span>
                    <span>{{ info.phone }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>電郵：</span>
                    <span>{{ info.email }}</span>
                  </div>
                </div>
                <div class="w-50">
                  <div class="d-flex">
                    <span>傳真：</span>
                    <span>{{ info.fax }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pdf-bottom">
            {{ `P.${pageIndex + 1}/${pages.length}` }}
          </div>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardBody, BCardText } from "bootstrap-vue";
import store from "@/store";

import { mapFields } from "vuex-map-fields";
import { ref, watch, computed, onMounted } from "@vue/composition-api";
import { formatMoney } from "@/libs/helper.js";

export default {
  data() {
    return {
      month: [
        "Jan",
        "Feb",
        "March",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      pages: [],
    };
  },
  methods: {
    formatMoney,
    changeDate(dateToChange) {
      var newDate = new Date(dateToChange);
      newDate.toLocaleString("default", { month: "long" });
      return (
        newDate.getDate() +
        " " +
        this.month[newDate.getMonth()] +
        " " +
        newDate.getFullYear()
      );
    },
    getNumberFormat(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HKD",
        minimumFractionDigits: 0,
      });
      return formatter.format(amount);
    },
    changeNextLine(str) {
      // 處理不同的資料類型
      if (!str) {
        return "";
      }

      // 如果是字串，直接處理
      if (typeof str === 'string') {
        return str.replace(/\n/g, "<br>");
      }

      // 如果是物件且有 content 屬性（例如備註物件）
      if (typeof str === 'object' && str.content) {
        return typeof str.content === 'string' ? str.content.replace(/\n/g, "<br>") : "";
      }

      // 如果是物件且有 title 屬性
      if (typeof str === 'object' && str.title) {
        return typeof str.title === 'string' ? str.title.replace(/\n/g, "<br>") : "";
      }

      // 如果是數字或其他原始類型，轉換為字串
      if (typeof str === 'number' || typeof str === 'boolean') {
        return String(str);
      }

      // 如果是陣列，嘗試連接元素
      if (Array.isArray(str)) {
        return str.map(item =>
          typeof item === 'string' ? item :
          (typeof item === 'object' && item.content) ? item.content :
          String(item)
        ).join('<br>');
      }

      // 其他情況，嘗試轉換為字串
      try {
        const stringValue = String(str);
        return stringValue !== '[object Object]' ? stringValue : "";
      } catch (error) {
        console.warn('changeNextLine: 無法處理的資料類型', str);
        return "";
      }
    },
    getTotalAmount() {
      var totalAmount = 0;
      if (this.pdfData.refund_items) {
        this.pdfData.refund_items.forEach((item) => {
          totalAmount += item.amount;
        });
      }
      return totalAmount;
    },
    splitIntoPages() {
      // 檢查 refund_items 是否存在且為陣列
      if (!this.pdfData || !this.pdfData.refund_items || !Array.isArray(this.pdfData.refund_items)) {
        this.pages = [];
        return;
      }

      const pageHeight = 549;
      let currentPage = [];
      let currentHeight = 0;
      const counted_array = this.pdfData.refund_items.map((item, index) => ({
        ...item,
        count: index + 1,
      }));

      this.pages = counted_array.reduce((acc, item, index) => {
        var itemHeight = this.calculateItemHeight(item.item_description);

        if (currentHeight + itemHeight > pageHeight) {
          acc.push(currentPage);
          currentPage = [];
          currentHeight = 0;
        }
        currentPage.push(item);
        currentHeight = Math.round((currentHeight + itemHeight) * 100) / 100;

        if (index === this.pdfData.refund_items.length - 1) {
          acc.push(currentPage);
        }
        return acc;
      }, []);

      // 处理备注
      if (this.pdfData.remark) {
        const remarkHeight = this.calculateItemHeight(this.pdfData.remark);
        const remark_item = {
          is_remark: true,
          id: null,
          item_description: this.pdfData.remark,
          quantity: null,
          unit_price: null,
          amount: null,
        };

        if (
          this.pages.length === 0 ||
          currentHeight + remarkHeight > pageHeight
        ) {
          this.pages.push([remark_item]);
        } else {
          this.pages[this.pages.length - 1].push(remark_item);
        }
      }

      // 触发更新
      this.$forceUpdate();
    },

    calculateItemHeight(item) {
      const baseHeight = 19.68; // 基础高度
      if (!item) {
        return baseHeight;
      }

      // 创建临时元素来计算实际高度
      const tempDiv = document.createElement("div");
      tempDiv.style.cssText = `
        position: absolute;
        visibility: hidden;
        width: 193px; // 款項摘要欄位的寬度
        font-size: 14px; // 确保字体大小与实际显示一致
        line-height: 1.2; // 设置行高
        white-space: pre-wrap; // 保留换行符并自动换行
      `;

      // 将HTML内容设置到临时元素
      tempDiv.innerHTML = item;
      document.body.appendChild(tempDiv);

      // 获取实际高度
      const actualHeight = tempDiv.offsetHeight;

      // 清理临时元素
      document.body.removeChild(tempDiv);

      // 返回计算后的高度，确保至少有基础高度
      return Math.max(baseHeight, Math.round(actualHeight * 100) / 100);
    },
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
  },
  props: {
    pdfData: {
      type: Object,
      required: true,
    },
    templateOptions: {
      type: Array,
      required: true,
    },
    stampOptions: {
      type: Array,
      required: true,
    },

  },

  mounted() {
    // this.$nextTick(() => {
    //     setTimeout(() => {
    //         this.$emit("domRendered");
    //     }, 1000);
    // });
  },
  watch: {
    "pdfData.refund_items": {
      handler() {
        this.splitIntoPages();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapFields(["controlValue"]),
  },
  setup(props) {
    const info = ref({
      website: null,
      address: null,
      phone: null,
      fax: null,
      email: null,
      company_info: null,
      logo_url: null,
    });
    const invoiceOptions = ref(null);
    const paymentMethodOptions = ref(null);
    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          invoices: true,
          payment_methods: true,
        })
        .then((response) => {
          invoiceOptions.value = response.data.invoices;
          paymentMethodOptions.value = response.data.payment_methods;
        });
    };

    const getInfo = (template_id, stamp_id) => {
      let template =
        props.templateOptions &&
        props.templateOptions.find((ele) => ele.id == template_id);

      let stamp =
        props.stampOptions &&
        props.stampOptions.find((ele) => ele.id == stamp_id);
      if (template) {
        info.value.website = template.website;
        info.value.address = template.address;
        info.value.phone = template.phone;
        info.value.fax = template.fax;
        info.value.email = template.email;
        info.value.company_info = template.company_info;
        info.value.bank_info = template.bank_info;
        info.value.logo_url = template.logo_url;
        info.value.stamp_url = stamp ? stamp.image_url || '' : '';
      }
    };
    watch(
      () => props.pdfData,
      (newVal, oldVal) => {
        if (newVal && newVal.template_id && init) {

          getInfo(newVal.template_id, newVal.stamp_id);
          init = false;
        }
      }
    );

    var init = true;

    onMounted(() => {
      refetchOption();
    });

    return {
      invoiceOptions,
      paymentMethodOptions,
      info,
    };
  },
};
</script>

<style lang="scss" scoped>
.stamp_logo{
  margin-left:-20px;
  top:-30px;
}
.pdf-add-wrapper .company-info *{
  font-size:14px;
}
</style>